import { Component, DoCheck, ElementRef, EventEmitter, HostBinding, inject, Input, OnInit, Output } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { FormsModule, NgControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { MinsterFormFieldComponent } from "../minster-form-field/minster-form-field.component";
import { StateService } from '../../../services/state.service';

@Component({
    selector: 'app-yes-no',
    standalone: true,
    imports: [FormsModule],
    templateUrl: './yes-no.component.html',
    styleUrl: './yes-no.component.css',
    providers: [{ provide: MatFormFieldControl, useExisting: YesNoComponent }],
})
export class YesNoComponent implements MatFormFieldControl<boolean>, OnInit, DoCheck {
    ngControl = null;
    autofilled?: boolean | undefined;
    disableAutomaticLabeling?: boolean | undefined;
    errorState: boolean = false;

    private readonly _elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

    theParentControl?: NgControl;

    @Input('value') _value!: boolean | null;
    @Input('required') required: boolean = false;
    @Input('disabled') _disabled: boolean = false;
    @Input('placeHolder') _placeHolder: string = '';
    @Input('name') _name: string = '';

    @Output() onValueChange = new EventEmitter<boolean | null>();

    constructor(private stateService: StateService) { }

    @Input()
    get control(): NgControl {
        return this.theParentControl!;
    }
    set control(control: NgControl) {
        this.theParentControl = control;
    }

    onChange(val: boolean) {
        this._value = val;
        this.focused = true;
        this.onValueChange.emit(val);
    }

    ngDoCheck() {
        const hasRequiredValidator = this.theParentControl?.control?.hasValidator(Validators.required)!;
        const isRequired = hasRequiredValidator && (this._value === undefined || this._value == null);
        const newErrorState = isRequired && this.stateService.formIsSubmitted;

       if(newErrorState != this.errorState){
            this.errorState = isRequired;
            this.stateChanges.next();
       }
    }

    ngOnInit(): void {
        this.disabled = this._disabled;
        this.id = this._name
    }

    // MatFormFieldControl
    @Input()
    get value(): boolean | null {
        return this._value;
    }
    set value(val: boolean | null) {
        this._value = val;
        this.stateChanges.next();
    }

    stateChanges = new Subject<void>();
    id = 'yes_no';

    @Input()
    get placeholder() {
        return this._placeHolder;
    }
    set placeholder(plh) {
        this._placeHolder = plh;
        this.stateChanges.next();
    }

    onFocusIn() {
        if (!this.focused && this._disabled == false) {
            this.focused = true;
            this.stateChanges.next();
        }
    }

    onFocusOut(event: FocusEvent) {
        if (!this._elementRef.nativeElement.contains(event.relatedTarget as Element)) {
            this.focused = false;
            this.stateChanges.next();
        }
    }

    focused = false;

    get empty() {
        return this._value === null || this._value === undefined;
    }

    @HostBinding('class.floating')
    get shouldLabelFloat() {
        return true;
    }

    disabled = false;

    controlType? = 'minster-yes-no';

    @Input('aria-describedby') userAriaDescribedBy?: string;


    setDescribedByIds(ids: string[]): void {

    }

    onContainerClick(event: MouseEvent): void {
    }
}
